import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'space-around',
  },
  title: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#1a334d',
    paddingLeft: '5px',
  },
  line: {
    border: '1px solid #d8d8d8',
    marginLeft: theme.spacing(2),
    flexGrow: 1,
  },
}));